module.exports = __webpack_public_path__ + "img/nol-active.31c785e9.png";